import logo from "../image/logo.svg";

export default {
  colorPrimary: "#131248",
  fontFamily: "Inter, sans-serif",

  page_dashboard__card_quick_start_background: "rgba(61, 71, 130, 0.45)",
  page_dashboard__card_quick_start_background_hover: "#3D4782",

  advisor_page_dashboard_show_sections_news: false,
  advisor_page_dashboard_video_link:
    "https://www.youtube.com/watch?v=l9L58EJ7oA4",
  advisor_page_dashboard_right_side_section_background: "#131247",
  advisor_page_dashboard_right_side_section_title_color: "#fff",
  advisor_page_dashboard_right_side_section_title_copy: "From BX",
  admin_pie_chart_color_primary: "#F36835",
  admin_pie_chart_color_secondary: "#BEC8CE",
  admin_pie_chart_color_tertiary: "#354A5F",
  admin_pie_chart_color_rest: "#72C0C7",
  page_dashboard__background: "#EDEFEF",
  page_dashboard__hero_background: "#131248",
  page_builder__background: "#151349",
  button_add_user_background: "#184073",
  chart_colors: ["#4E96D1", "#1A2849", "#64C981", "#CCB681dok", "#00BDC4"],
  color_admin_analytic_value: "#131523",
  button_primary_background: "#428A16",
  color_secondary_button: "#4897D1",
  color_secondary_button_text: "#FFFFFF",
  color_tertiary_button: "#E7EBEE",
  color_tertiary_button_text: "#516474",
  comparison_products_colors: ["#E48361", "#83C390", "#679BCE"],
  hideTabNextLeads: true,
  logo_src: logo,
  overlay_background: "rgba(39, 90, 144, 0.8)",
  proposal_guide_font_primary: "Barlow, sans-serif",
  quarterly_goal_aum_color: "#3B92B7",
  quarterly_goal_client_color: "#4F8083",
  quarterly_goal_proposal_color: "#215054",
  sidebar_menu_item_color: "#141248",
  sidebar_menu_item_hover_background: "#fff",
  sidebar_profile_color: "#141248",
  sidebar_background: "#e0e2e8",
  sidebar_color: "#141248",
  sidebar_icon_color: "#FFFFFF60",
  sidebar_logo: logo,
  sidebar__width: 200,
  spin_color: "#fff",
  tenant_color_primary: "#141248",
};
